import React, { useState, useEffect, useRef } from "react";
import styles from './Dropdown.module.scss';
import Checkbox from '../../components/Checkbox/Checkbox';
import { makeDeepCopy } from "helpers/utils";

const Dropdown = ({
    button,
    configuration,
    dropdownHeader,
    dropdowHeaderTitle,
    multipleSelect,
    options,
    onChange
}) => {
    const wrapperRef = useRef(null);

    const [dropdownOptions, setDropdownOptions] = useState(options || []);
    const [isMenuVisible, setIsMenuVisible] = useState(false);

    useEffect(() => {
        if (dropdownOptions && dropdownOptions.length > 0) {
            onChange(dropdownOptions);
        }
    }, [dropdownOptions]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsMenuVisible(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    const areAllCheckboxesChecked = (dropdownOptions) => {
        if (dropdownOptions.some((dropdownOption) => !dropdownOption.toggleAll && !dropdownOption.checked)) return false;
        return true;
    }
    
    const handleCheckbox = (e, optionId) => {
        const dropdownOptionsCopy = makeDeepCopy(dropdownOptions);
        const currentOption = dropdownOptionsCopy.find((opt) => opt.id === optionId);

        if (currentOption.toggleAll) {
            // toggle all checkbox
            setDropdownOptions(dropdownOptionsCopy.map((dropdownOption) => {
                dropdownOption.checked = e.target.checked;
                return dropdownOption;
            }));
            return;
        }

        // other than toggle all checkbox
        currentOption.checked = e.target.checked;
        const toggleAllCheckbox = dropdownOptionsCopy.find((opt) => opt.toggleAll);
        toggleAllCheckbox.checked = areAllCheckboxesChecked(dropdownOptionsCopy);
        setDropdownOptions(dropdownOptionsCopy);
    }

    const toggleMenu = () => {
        setIsMenuVisible(!isMenuVisible);
    }

    return (
        <div className={styles.dropdown} ref={wrapperRef}>
            {button && configuration && (
                <div className={isMenuVisible ? `${styles['config-button']} ${styles.active}` : styles['config-button']} onClick={toggleMenu}>
                    <i className={`${styles['config-button-cog']} fal fa-cog`}></i><i className={`${styles['config-button-sort-down']} fas fa-sort-down`}></i>
                </div>
            )}
            
            { isMenuVisible && <div className={styles.menu}>
                {dropdownHeader && (
                    <div className={styles['menu-header']}>
                        {dropdowHeaderTitle}
                    </div>
                )}
                
                {multipleSelect && (
                    <div className={styles['menu-body']}>
                        { dropdownOptions && dropdownOptions.length > 0 && dropdownOptions.map((option) => {
                            return <Checkbox
                                        id={option.id}
                                        key={option.id}
                                        name={`dropdown`}
                                        onChange={(e) => handleCheckbox(e, option.id)}
                                        checked={option.checked}
                                        labelText={option.label}
                                        className={styles.checkbox}
                                    />
                        })}
                    </div>
                )}
            </div>}
        </div>
    );
}

export default Dropdown;
